import { MESSAGE_STATUSES } from "../../../../packages/constants";
import { helpers } from "../../../../packages/helpers";
import type { Message } from "../../types";

const { isMessageReceived } = helpers.predicates;
const FIRST = 0;
const OFFSET = 1;

type Params = {
  messages: Array<Message>;
  lastReadMessageIndex: number;
  lastReadMessageId: string;
  userId: string;
};

export const getMessagesWithReadStatusesByIndex = ({
  messages,
  lastReadMessageIndex,
  lastReadMessageId,
  userId,
}: Params) => {
  const firstUnreadMessageIndex = lastReadMessageIndex + OFFSET;
  const prevReadMessages = messages.slice(FIRST, firstUnreadMessageIndex);
  const unreadMessages = messages.slice(firstUnreadMessageIndex);

  const intermediateReadIndex = unreadMessages.findIndex(
    ({ id }) => id === lastReadMessageId
  );

  const intermediateFirstUnreadIndex = intermediateReadIndex + OFFSET;
  const intermediateReadMessages = unreadMessages.slice(
    FIRST,
    intermediateFirstUnreadIndex
  );

  const newUnreadMessages = unreadMessages.slice(intermediateFirstUnreadIndex);

  const updatedReadMessages = intermediateReadMessages.map((message) => {
    const { authorId } = message;

    return userId === authorId && isMessageReceived(message.status)
      ? { ...message, status: MESSAGE_STATUSES.READ }
      : message;
  });

  const newReadMessages = [...prevReadMessages, ...updatedReadMessages];

  const newLastReadMessageIndex = newReadMessages.length - 1;
  const newMessages = [...newReadMessages, ...newUnreadMessages];

  return { newMessages, newLastReadMessageIndex };
};
